import React, {useContext, useState, useEffect} from 'react';
import Layout from '../components/Layout';
import BannerInner from '../components/BannerInner';
import Counter from '../components/Counter';
import banner1 from '../assets/images/img1.jpg';
import banner2 from '../assets/images/img2.jpg';
import WhatLookingFor from '../components/WhatLookingFor';
import WhyChooseUs from '../components/WhyChooseUs';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import {BsFileEarmarkText, BsEye, BsRocketTakeoff} from "react-icons/bs";
import CommonHelmet from '../components/CommonHelmet';
import Button from '../components/Button';
import { ModalContext } from '../context/ModalContext';
import axios from 'axios';

const About = () => {
    const title='Real Estate Consultant in Lucknow | Best Real Estate Company';
    const description='Urbanaid Infratech is the leading Property Consultants in Lucknow. We are a top class real estate builders in Lucknow. Visit urbanaidinfratech.com to check upcoming projects.';
    const canonical='/about-us';

    // const [metaData, setMetaData] = useState({
    //     metatitle: '',
    //     metadescription: '',
    //     canonical: '',
    // });

    // useEffect(() => {
    //     const fetchMeta = async () => {
    //         try {
    //         const res = await axios.get("/api/getmeta/about"); // backend API for "about"
    //         setMetaData({
    //             metatitle: res.data.metatitle || "Default About Title",
    //             metadescription: res.data.metadescription || "Default description",
    //             canonical: res.data.canonical || "/about",
    //         });
    //         } catch (err) {
    //         console.error("Error fetching meta:", err);
    //         }
    //     };

    //     fetchMeta();
    // }, []);

    const modalContext = useContext(ModalContext);
    const [aboutData, setAboutData] = useState({
        years: '',
        heading: '',
        content: '',
        history: '',
        mission: '',
        vision: '',
    });
    useEffect(() => {
        const fetchData = async () => {
        try {
            const res = await axios.get("/api/fetchabout"); // Adjust port if needed
            const fetchedData = res.data[0]; // Assuming data is an array
            setAboutData({
                years: fetchedData.years || '',
                heading: fetchedData.heading || '',
                content: fetchedData.content || '',
                history: fetchedData.history || '',
                mission: fetchedData.mission || '',
                vision: fetchedData.vision || '',
            });
            console.log(aboutData);
        } catch (err) {
            console.error("Error fetching data:", err);
        }
        };
        fetchData();
    }, []);

    return (
        <>
            <CommonHelmet title={title} canonical={canonical} description={description} />
            <BannerInner title={'About Company'} />
            <section className='aboutus flex py-8'>
                <div className='container mx-auto'>
                    <div className='flex flex-col md:flex-row justify-start md:justify-end pb-10 mb-5 relative'>
                        <div className='relative w-full md:w-1/3 h-auto flex justify-start items-start text-center'>
                            <div className='aboutimg w-full h-full z-20 ps-10 pb-10'>
                                <Swiper
                                    loop={true}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                    }}
                                    pagination={{
                                        clickable: true,
                                    }}  
                                    //navigation={true}
                                    modules={[Autoplay, Pagination]}
                                    className="mySwiperAbout"
                                >
                                    <SwiperSlide>
                                        <img src={banner1} alt={''} className='w-full' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src={banner2} alt={''} className='w-full' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src={banner1} alt={''} className='w-full' />
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <img src={banner2} alt={''} className='w-full' />
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                        <div className='about-detail w-full md:w-2/3 mt-10 md:mt-0 z-10 px- md:px-12 text-gray-600 gap-3'>
                            <div className='about-years flex flex-col justify-start items-start border-l-8 border-solid border-orange-500 px-5 mb-7 py-3'>
                                <h2>{aboutData.years}</h2>
                                <h3>{aboutData.heading}</h3>
                            </div>
                            <div className='prose' dangerouslySetInnerHTML={{ __html: aboutData.content }}>
                                
                            </div>
                            <div className='flex mt-4'>
                                <Button type='button' className='hover:bg-orange-500 hover:text-white' variant='primary' onClick={() => modalContext.setShowEnquiryPopup(true)}>Get in Touch</Button>
                            </div>
                        </div>                    
                    </div>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
                        <div className='specs flex flex-col border border-gray-200 border-solid border-t-8 border-t-orange-500 px-7 py-5 text-gray-600 text-left relative'>
                            <div className='countnum absolute top-0 right-5 opacity-10 text-8xl font-extrabold'>1</div>
                            <BsFileEarmarkText className='icon text-4xl text-orange-500 opacity-50 mb-2' />
                            <h3 className='text-lg font-semibold text-gray-900 py-1'>Our History</h3>
                            <p>{aboutData.history}</p>
                        </div>
                        <div className='specs flex flex-col border border-gray-200 border-solid border-t-8 border-t-orange-500 px-7 py-5 text-gray-600 relative'>
                            <div className='countnum absolute top-0 right-5 opacity-10 text-8xl font-extrabold'>2</div>
                            <BsRocketTakeoff className='icon text-4xl text-orange-500 opacity-50 mb-2' />
                            <h3 className='text-lg font-semibold text-gray-900 py-1'>Our Mission</h3>
                            <p>{aboutData.mission}</p>
                        </div>
                        <div className='specs flex flex-col border border-gray-200 border-solid border-t-8 border-t-orange-500 px-7 py-5 text-gray-600 relative'>
                            <div className='countnum absolute top-0 right-5 opacity-10 text-8xl font-extrabold'>3</div>
                            <BsEye className='icon text-4xl text-orange-500 opacity-50 mb-2' />
                            <h3 className='text-lg font-semibold text-gray-900 py-1'>Our Vision</h3>
                            <p>{aboutData.vision}</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='counter flex py-8 bg-slate-950'>
                <div className='container mx-auto'>
                    <div className='w-full my-4 py-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 grid-flow-row auto-rows-auto gap-10'>
                        <Counter />
                    </div>
                </div>
            </section>
            <WhatLookingFor />
            <WhyChooseUs />
        </>
    );
}

export default About;

